module.exports = __webpack_public_path__ + "buyer-2.jpg?0582a7d7db18b6a8245e7dd3d3d7b63a";